<template>
<svg width="31px" height="33px" viewBox="0 0 31 33" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Group" stroke="#000000" transform="translate(1.000000, 1.586914)">
            <polygon id="Path" points="15 24.7033691 3.12250226e-16 6.81225586 5.65698242 -2.33968391e-16 24.2871094 0 29.2385254 7.40893555"></polygon>
            <polyline id="Path-2" stroke-linecap="square" stroke-linejoin="bevel" points="5.65698242 0 15 24.7033691 24.2871094 0"></polyline>
            <line x1="0" y1="6.81225586" x2="29.2385254" y2="6.81225586" id="Path-3"></line>
            <polyline id="Path-4" points="8.55981445 6.81225586 15.4978027 1.20158752e-16 21.5507812 6.81225586"></polyline>
            <path d="M3.57836914,14.6022949 C0.237548828,17.0228678 -0.59765625,19.5253092 1.07275391,22.1096191 C2.74316406,24.693929 7.3633572,26.6592611 14.9333333,28.0056152" id="Path-5"></path>
            <path d="M20.5344238,26.8649902 C25.9183974,25.5778809 28.8197645,23.7242025 29.2385254,21.3039551 C29.6572862,18.8837077 28.7952257,16.649821 26.6523438,14.6022949" id="Path-6"></path>
            <polyline id="Path-7" points="12.4846191 25.473877 15.0552979 28.0056152 12.4846191 30.4594727"></polyline>
        </g>
    </g>
</svg>
</template>
<script>
export default {}
</script>